import { layoutCardsCount } from "./constants/constants";
import { FESTIVAL_SORT } from "../types";
import { ParsedUrlQuery } from "querystring";
import { homePageStaticSlidersData } from "@features/home/helpers/constants";
import homeApi from "@features/home/helpers/homeApi";
import { PRODUCT_SLUG } from "@types";
import { toEnglishDigits } from "@utils/digits";

export const buildFestivalProductParams = (
  query: ParsedUrlQuery
): {
  sort: FESTIVAL_SORT;
  page: number;
  count: number;
  category_id?: string;
} => {
  const { sort, page, category } = query;
  const base = {
    sort: (sort as FESTIVAL_SORT) || "popularity",
    page: Number(page) || 1,
    count: layoutCardsCount,
  };
  return typeof category === "string" && category
    ? { ...base, category_id: category }
    : base;
};

export const buildStaticSliderFetchers = () => {
  const categoryIds = homePageStaticSlidersData
    .map((slider) => slider.tabs?.[0]?.id)
    .filter(Boolean) as number[];

  return categoryIds.map((category_id) =>
    homeApi.getHomeCards(PRODUCT_SLUG.MOST_RATE_PRODUCT_MONETARY, {
      category_id,
    })
  );
};

export const getDiscountNumber = (discountText?: string) => {
  if (!discountText) return undefined;

  const value = Number(toEnglishDigits(discountText) || "".replace(/\D/g, ""));

  if ([40, 50, 60, 65, 70, 75, 80].includes(value)) {
    return value as 40 | 50 | 60 | 65 | 70 | 75 | 80;
  }

  return undefined;
};
